import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withKeys as _withKeys, unref as _unref, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("全部");

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 重置");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("添加");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("团队列表导出");

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 编辑 ");

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 业务管理 ");

const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 绑定租户 ");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("销售团队");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("国代团队");

const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 取消 ");

const _hoisted_12 = /*#__PURE__*/_createTextVNode("确定");

import { ref, computed, onMounted, nextTick } from 'vue';
import router from '@/router';
import { getControlSalesTeamList, getSupplierMerCount, exportForAsync, getSysAreaTree } from '@/request';
import { exportTeamList } from '@/request/api';
import { getVexTableProps } from '@/config';
import { useStore } from 'vuex';
import { ElMessage } from 'element-plus';
import AddControlSalesTeamModal from './component/AddControlSalesTeamModal.vue';
import BindSmartkbTenantModal from './component/BindSmartkbTenantModal.vue';
export default {
  name: 'ControlSalesTeam',

  setup(__props) {
    const form = ref({
      supplierName: '',
      linkMan: '',
      linkPhone: '',
      prodNo: '',
      prodName: '',
      busiScop: []
    });
    const store = useStore(); // store.dispatch('getDictList');
    // const dictList = computed(() => {
    //   let list = store.state.dictList;
    //   // list.unshift({ text: '全部', id: '' })
    //   return list;
    // });

    const userType = computed(() => store.state.user.userType); // 仅分管账号可绑定智能客服租户

    const canBindTenant = computed(() => Number(userType.value) === 2);
    const table = ref();
    const exportAuth = ref(false);
    const formRef = ref();
    const showAddControlSalesTeamModal = ref(false);
    const editData = ref(null);
    const showChooseSupplierTypeDialog = ref(false);
    const addSupplierCategory = ref(2);
    const showBindSmartkbTenantModal = ref(false);
    const bindTenantTeam = ref(null);
    let total = 0;

    function reset() {
      formRef.value.resetFields();
      table.value.commitProxy('reload');
    }

    function add() {
      showAddControlSalesTeamModal.value = true;
      editData.value = null;
    }

    function addSupplier() {
      showChooseSupplierTypeDialog.value = true;
    }

    function chooseSupplierCategory() {
      console.log('chooseSupplierCategory.value', addSupplierCategory.value);
    }

    function saveSupplierCategory() {
      console.log('saveSupplierCategory.value', addSupplierCategory.value);
      showChooseSupplierTypeDialog.value = false;
      router.push({
        name: 'BatchControlSalesTeam',
        query: {
          supplierCategory: addSupplierCategory.value
        }
      }, true);
    }

    function edit(row) {
      showAddControlSalesTeamModal.value = true;
      editData.value = row;
    }

    function bindTenant(row) {
      bindTenantTeam.value = row;
      showBindSmartkbTenantModal.value = true;
    }

    function exportExcel() {
      exportForAsync(_objectSpread(_objectSpread({}, form.value), {}, {
        count: total,
        fileName: '团队列表明细',
        modularflag: 'supplierDetail',
        methodName: exportTeamList.url
      }));
    }

    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '团队名称',
        field: 'supplierName',
        width: '150px',
        showOverflow: true
      }, {
        title: '团队类型',
        field: 'supplierCategoryName',
        width: '150px',
        showOverflow: true
      }, {
        title: '团队业务区域',
        field: 'supBusiScopName',
        width: '250px',
        showOverflow: true
      }, {
        title: '联系人',
        field: 'linkMan',
        width: '150px',
        showOverflow: true
      }, {
        title: '联系人电话',
        field: 'linkPhone',
        width: '200px',
        showOverflow: true
      }, {
        title: '创建时间',
        field: 'createAt',
        width: '200px',
        showOverflow: true
      }, {
        title: '智能客服租户',
        field: 'smartkbTenantName',
        width: '150px',
        showOverflow: true,
        formatter: ({
          row
        }) => row.smartkbTenantName || row.smartkbTenantSlug || '未绑定'
      }, {
        title: '操作',
        width: '360px',
        fixed: 'right',
        slots: {
          default: 'operation'
        }
      }],
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getControlSalesTeamList(_objectSpread(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize
            }, form.value), {}, {
              busiScop: form.value.busiScop.join(',')
            })).then(data => {
              total = data.total;
              exportAuth.value = data.exportAuth;
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    }); // 业务区域选择相关

    const busiScopCheckAll = ref(false);

    function busiScopChangeHandle(valueList) {
      if (valueList.length === dictList.value.length) {
        busiScopCheckAll.value = true;
      } else {
        busiScopCheckAll.value = false;
      }
    }

    function busiScopCheckAllHandle() {
      if (busiScopCheckAll.value) {
        form.value.busiScop = dictList.value.map(v => v.id);
      } else {
        form.value.busiScop = [];
      }
    } // 全国区域树


    const dictList = ref([]);

    function getTreeData() {
      return getSysAreaTree({
        adCode: 100000
      }).then(res => {
        let {
          success,
          data
        } = res;
        dictList.value = success ? data : [];
      });
    }

    onMounted(() => getTreeData());
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [_createVNode(_component_el_form, {
        model: form.value,
        ref_key: "formRef",
        ref: formRef,
        "label-width": "100px",
        onKeydown: _cache[7] || (_cache[7] = _withKeys($event => table.value.commitProxy('reload'), ["enter"]))
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "团队名称",
              prop: "supplierName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.supplierName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.supplierName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "联系人",
              prop: "linkMan"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.linkMan,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.linkMan = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "联系人电话",
              prop: "linkPhone"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                type: "number",
                modelValue: form.value.linkPhone,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.linkPhone = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "商品编码",
              prop: "prodNo"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.prodNo,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.prodNo = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "商品名称",
              prop: "prodName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.prodName,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.prodName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "业务区域",
              prop: "busiScop"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                multiple: "",
                modelValue: form.value.busiScop,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.busiScop = $event),
                "collapse-tags": "",
                onChange: busiScopChangeHandle
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  disabled: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_checkbox, {
                    modelValue: busiScopCheckAll.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => busiScopCheckAll.value = $event),
                    onChange: busiScopCheckAllHandle
                  }, {
                    default: _withCtx(() => [_hoisted_1]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dictList.value, dict => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: dict.text,
                    value: dict.id,
                    key: dict.id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: _cache[8] || (_cache[8] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
        ref_key: "table",
        ref: table
      }), {
        tools: _withCtx(() => [_unref(userType) !== 3 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          icon: "Plus",
          onClick: add
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })) : _createCommentVNode("", true), exportAuth.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          icon: "Download",
          onClick: exportExcel
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })) : _createCommentVNode("", true)]),
        operation: _withCtx(({
          row
        }) => [_unref(userType) !== 3 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          icon: "Edit",
          onClick: $event => edit(row)
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          type: "success",
          icon: "Management",
          onClick: $event => _ctx.$router.push({
            name: 'BusinessManage',
            query: {
              supplierId: row.supplierId,
              storeType: row.supplierCategory,
              from: _ctx.$route.name
            }
          }, true)
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 2
        }, 1032, ["onClick"]), _unref(canBindTenant) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "warning",
          icon: "Service",
          onClick: $event => bindTenant(row)
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
        _: 1
      }, 16), _createVNode(AddControlSalesTeamModal, {
        modelValue: showAddControlSalesTeamModal.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => showAddControlSalesTeamModal.value = $event),
        dictList: dictList.value,
        editData: editData.value,
        onSuccess: _cache[10] || (_cache[10] = $event => table.value.commitProxy('query'))
      }, null, 8, ["modelValue", "dictList", "editData"]), _createVNode(BindSmartkbTenantModal, {
        modelValue: showBindSmartkbTenantModal.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => showBindSmartkbTenantModal.value = $event),
        team: bindTenantTeam.value,
        onSuccess: _cache[12] || (_cache[12] = $event => table.value.commitProxy('query'))
      }, null, 8, ["modelValue", "team"])]), _createVNode(_component_el_dialog, {
        modelValue: showChooseSupplierTypeDialog.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => showChooseSupplierTypeDialog.value = $event),
        title: "请选择需要增加的团队类型",
        width: "350px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[14] || (_cache[14] = $event => showChooseSupplierTypeDialog.value = false)
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: saveSupplierCategory
        }, {
          default: _withCtx(() => [_hoisted_12]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: addSupplierCategory.value,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => addSupplierCategory.value = $event),
          onChange: chooseSupplierCategory
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            label: 2
          }, {
            default: _withCtx(() => [_hoisted_9]),
            _: 1
          }), _createVNode(_component_el_radio, {
            label: 1
          }, {
            default: _withCtx(() => [_hoisted_10]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }

};